import * as React from "react";

import styled from "../../theme/styled";
import DynamicImage from "../dynamic-image";
import {
  DynamicWrapper,
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphImagesSideBySideColumnWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
}

const ParagraphImagesSideBySideColumnWrapper = styled<
  IParagraphImagesSideBySideColumnWrapper,
  "div"
>("div")`
  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .image {
      padding-top: 8%;
      width: 100%;

      &:first-child {
        padding-top: 0;
      }
    }
  }

  @media (min-width: 600px) {
    .content-wrapper {
      .image {
        padding-top: 4.4rem;
      }
    }
  }

  @media (min-width: 768px) {
    .content-wrapper {
      flex-direction: row;

      .image {
        padding-top: 0;
        width: 50%;

        &:nth-child(odd) {
          padding-right: 2%;
        }

        &:nth-child(even) {
          padding-left: 2%;
        }
      }
    }
  }
`;

const ParagraphImagesSideBySideColumn = ({ type, content }: IProps) => {
  const imgRels = content.relationships;
  const images = imgRels && imgRels.field_images ? imgRels.field_images : [];

  if (images.length === 0) {
    return null;
  }

  return (
    <ParagraphImagesSideBySideColumnWrapper
      className="paragraph-side-by-side-image"
      type={type}
    >
      <DynamicWrapper type={type}>
        <div className="content-wrapper">
          {images &&
            images.map((image, i: number) => (
              <div
                className="image"
                key={i}
              >
                <DynamicImage
                  data={image}
                  alt={content.field_images[ i ].alt}
                />
              </div>
            ))}
        </div>
      </DynamicWrapper>
    </ParagraphImagesSideBySideColumnWrapper>
  );
};

export default ParagraphImagesSideBySideColumn;
